import React from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'

const Video = ({intl: { formatMessage }}) => (
  <section id="video" className="section text-center section text-center video clearfix" aria-labelledby="video">
    <div className="container">
      <div className="row">
        <div className="col-sm-12 col-md-8 offset-md-2">
          <div data-aos="fade-up" className="aos-init aos-animate">
            <h1 id="region-video" className="section__title">
              <FormattedMessage id="guarda-il-video"/>
            </h1>
            <div className="iframe-responsive">
              <iframe src="https://www.youtube-nocookie.com/embed/fduPcIV3ufo?rel=0&amp;showinfo=0" width="560" height="315" 
                title={formatMessage({id: "guarda-il-video"})} frameBorder="0" allowFullScreen></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default injectIntl(Video);